/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: n2Wtjyx7XW44
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicPageInfoContainer.module.css"; // plasmic-import: n2Wtjyx7XW44/css

createPlasmicElementProxy;

export const PlasmicPageInfoContainer__VariantProps = new Array(
  "containerType"
);

export const PlasmicPageInfoContainer__ArgProps = new Array(
  "showHelperText",
  "stepHeader",
  "formElementsWrapper",
  "text2",
  "buttonsWrapper",
  "text",
  "text4",
  "stepInfo"
);

const $$ = {};

function PlasmicPageInfoContainer__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showHelperText: true
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "containerType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.containerType
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"infoContainer"}
      data-plasmic-override={overrides.infoContainer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.infoContainer,
        {
          [sty.infoContainercontainerType_formAndButtons]: hasVariant(
            $state,
            "containerType",
            "formAndButtons"
          ),
          [sty.infoContainercontainerType_justText]: hasVariant(
            $state,
            "containerType",
            "justText"
          ),
          [sty.infoContainercontainerType_simplified]: hasVariant(
            $state,
            "containerType",
            "simplified"
          ),
          [sty.infoContainercontainerType_textAndButtons]: hasVariant(
            $state,
            "containerType",
            "textAndButtons"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"hederWrapper"}
        data-plasmic-override={overrides.hederWrapper}
        className={classNames(projectcss.all, sty.hederWrapper, {
          [sty.hederWrappercontainerType_justText]: hasVariant(
            $state,
            "containerType",
            "justText"
          ),
          [sty.hederWrappercontainerType_textAndButtons]: hasVariant(
            $state,
            "containerType",
            "textAndButtons"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: "one step.",
          value: args.stepHeader,
          className: classNames(sty.slotTargetStepHeader)
        })}
      </div>
      <div
        data-plasmic-name={"contentWrapper"}
        data-plasmic-override={overrides.contentWrapper}
        className={classNames(projectcss.all, sty.contentWrapper, {
          [sty.contentWrappercontainerType_justText]: hasVariant(
            $state,
            "containerType",
            "justText"
          ),
          [sty.contentWrappercontainerType_simplified]: hasVariant(
            $state,
            "containerType",
            "simplified"
          ),
          [sty.contentWrappercontainerType_textAndButtons]: hasVariant(
            $state,
            "containerType",
            "textAndButtons"
          )
        })}
      >
        <div
          data-plasmic-name={"slotFormElementsWrapper"}
          data-plasmic-override={overrides.slotFormElementsWrapper}
          className={classNames(projectcss.all, sty.slotFormElementsWrapper, {
            [sty.slotFormElementsWrappercontainerType_formAndButtons]:
              hasVariant($state, "containerType", "formAndButtons"),
            [sty.slotFormElementsWrappercontainerType_justText]: hasVariant(
              $state,
              "containerType",
              "justText"
            ),
            [sty.slotFormElementsWrappercontainerType_simplified]: hasVariant(
              $state,
              "containerType",
              "simplified"
            ),
            [sty.slotFormElementsWrappercontainerType_textAndButtons]:
              hasVariant($state, "containerType", "textAndButtons")
          })}
        >
          {(hasVariant($state, "containerType", "justText") ? false : true)
            ? renderPlasmicSlot({
                defaultContents: null,
                value: args.formElementsWrapper
              })
            : null}
        </div>
        <div
          className={classNames(projectcss.all, sty.freeBox__vUwRa, {
            [sty.freeBoxcontainerType_textAndButtons__vUwRAkC9J]: hasVariant(
              $state,
              "containerType",
              "textAndButtons"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.text2
          })}
        </div>
        <div
          data-plasmic-name={"slotButtonsWrapper"}
          data-plasmic-override={overrides.slotButtonsWrapper}
          className={classNames(projectcss.all, sty.slotButtonsWrapper, {
            [sty.slotButtonsWrappercontainerType_justText]: hasVariant(
              $state,
              "containerType",
              "justText"
            ),
            [sty.slotButtonsWrappercontainerType_simplified]: hasVariant(
              $state,
              "containerType",
              "simplified"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.buttonsWrapper
          })}
        </div>
        <div
          className={classNames(projectcss.all, sty.freeBox__kxaZd, {
            [sty.freeBoxcontainerType_justText__kxaZdXymu8]: hasVariant(
              $state,
              "containerType",
              "justText"
            ),
            [sty.freeBoxcontainerType_simplified__kxaZdV9XnN]: hasVariant(
              $state,
              "containerType",
              "simplified"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.text
          })}
        </div>
      </div>
      {(hasVariant($state, "containerType", "simplified") ? true : false) ? (
        <div
          data-plasmic-name={"contentWrapper2"}
          data-plasmic-override={overrides.contentWrapper2}
          className={classNames(projectcss.all, sty.contentWrapper2, {
            [sty.contentWrapper2containerType_justText]: hasVariant(
              $state,
              "containerType",
              "justText"
            ),
            [sty.contentWrapper2containerType_simplified]: hasVariant(
              $state,
              "containerType",
              "simplified"
            ),
            [sty.contentWrapper2containerType_textAndButtons]: hasVariant(
              $state,
              "containerType",
              "textAndButtons"
            )
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__nt2SD, {
              [sty.freeBoxcontainerType_justText__nt2SDXymu8]: hasVariant(
                $state,
                "containerType",
                "justText"
              ),
              [sty.freeBoxcontainerType_simplified__nt2SDv9XnN]: hasVariant(
                $state,
                "containerType",
                "simplified"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.text4
            })}
          </div>
        </div>
      ) : null}
      {(
        hasVariant($state, "containerType", "justText")
          ? true
          : hasVariant($state, "containerType", "textAndButtons")
            ? true
            : (() => {
                try {
                  return $props.showHelperText;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return true;
                  }
                  throw e;
                }
              })()
      ) ? (
        <div
          data-plasmic-name={"infotextWrapper"}
          data-plasmic-override={overrides.infotextWrapper}
          className={classNames(projectcss.all, sty.infotextWrapper, {
            [sty.infotextWrappercontainerType_justText]: hasVariant(
              $state,
              "containerType",
              "justText"
            ),
            [sty.infotextWrappercontainerType_simplified]: hasVariant(
              $state,
              "containerType",
              "simplified"
            ),
            [sty.infotextWrappercontainerType_textAndButtons]: hasVariant(
              $state,
              "containerType",
              "textAndButtons"
            )
          })}
        >
          {(hasVariant($state, "containerType", "justText") ? false : true)
            ? renderPlasmicSlot({
                defaultContents: "Helper text.",
                value: args.stepInfo,
                className: classNames(sty.slotTargetStepInfo, {
                  [sty.slotTargetStepInfocontainerType_justText]: hasVariant(
                    $state,
                    "containerType",
                    "justText"
                  ),
                  [sty.slotTargetStepInfocontainerType_simplified]: hasVariant(
                    $state,
                    "containerType",
                    "simplified"
                  ),
                  [sty.slotTargetStepInfocontainerType_textAndButtons]:
                    hasVariant($state, "containerType", "textAndButtons")
                })
              })
            : null}
        </div>
      ) : null}
    </div>
  );
}

const PlasmicDescendants = {
  infoContainer: [
    "infoContainer",
    "hederWrapper",
    "contentWrapper",
    "slotFormElementsWrapper",
    "slotButtonsWrapper",
    "contentWrapper2",
    "infotextWrapper"
  ],

  hederWrapper: ["hederWrapper"],
  contentWrapper: [
    "contentWrapper",
    "slotFormElementsWrapper",
    "slotButtonsWrapper"
  ],

  slotFormElementsWrapper: ["slotFormElementsWrapper"],
  slotButtonsWrapper: ["slotButtonsWrapper"],
  contentWrapper2: ["contentWrapper2"],
  infotextWrapper: ["infotextWrapper"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPageInfoContainer__ArgProps,
          internalVariantPropNames: PlasmicPageInfoContainer__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPageInfoContainer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "infoContainer") {
    func.displayName = "PlasmicPageInfoContainer";
  } else {
    func.displayName = `PlasmicPageInfoContainer.${nodeName}`;
  }
  return func;
}

export const PlasmicPageInfoContainer = Object.assign(
  // Top-level PlasmicPageInfoContainer renders the root element
  makeNodeComponent("infoContainer"),
  {
    // Helper components rendering sub-elements
    hederWrapper: makeNodeComponent("hederWrapper"),
    contentWrapper: makeNodeComponent("contentWrapper"),
    slotFormElementsWrapper: makeNodeComponent("slotFormElementsWrapper"),
    slotButtonsWrapper: makeNodeComponent("slotButtonsWrapper"),
    contentWrapper2: makeNodeComponent("contentWrapper2"),
    infotextWrapper: makeNodeComponent("infotextWrapper"),
    // Metadata about props expected for PlasmicPageInfoContainer
    internalVariantProps: PlasmicPageInfoContainer__VariantProps,
    internalArgProps: PlasmicPageInfoContainer__ArgProps
  }
);

export default PlasmicPageInfoContainer;
/* prettier-ignore-end */
